function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useMenuBalanceContext } from 'moduleBase/modules/menu-balance/hooks/use-menu-balance-context';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import * as React from 'react';

var MenuItemList = function MenuItemList() {
  var _useMenuBalanceContex = useMenuBalanceContext(),
      menu = _useMenuBalanceContex.menu,
      hide = _useMenuBalanceContex.hide;

  var list = menu.items.map(function (menuItem) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown-flat-list__item",
      key: menuItem.label
    }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
      onClick: function onClick() {
        hide();
      }
    })));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-list"
  }, list);
};

export { MenuItemList };